var _defs, _rect, _path, _g, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _path2, _circle, _circle2, _circle3, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjects05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1500 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f4e211;}.cls-2{fill:#ff715d;}.cls-3{clip-path:url(#clip-path);}.cls-4{clip-path:url(#clip-path-2);}.cls-5{fill:none;stroke:#000;stroke-linecap:round;stroke-miterlimit:10;stroke-width:3px;}.cls-6{fill:#e1dacf;}.cls-7{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M267.75,712.58,543.67,988.51a32.53,32.53,0,0,0,46,0l504.14-504.15a32.51,32.51,0,0,0,0-46l-278-277.95a32.5,32.5,0,0,0-46.06.09L267.66,666.7A32.5,32.5,0,0,0,267.75,712.58Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "284.29 749.51 855.56 183.22 1065.93 394.58 496.65 966.85 284.29 749.51"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "objects") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 362.32,
    y: 330.03,
    width: 317.94,
    height: 81.69,
    rx: 28.18,
    transform: "translate(-109.56 477.24) rotate(-45)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M267.75,712.58,543.67,988.51a32.53,32.53,0,0,0,46,0l504.14-504.15a32.51,32.51,0,0,0,0-46l-278-277.95a32.5,32.5,0,0,0-46.06.09L267.66,666.7A32.5,32.5,0,0,0,267.75,712.58Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "284.29 749.51 855.56 183.22 1065.93 394.58 496.65 966.85 284.29 749.51"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M922.11,305.23l85.52,83.08a14.92,14.92,0,0,1,.24,21.18L927.61,491"
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 706.51,
    cy: 556.09,
    rx: 205.84,
    ry: 203.38
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 706.51,
    cy: 556.09,
    rx: 168.01,
    ry: 166.01
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 706.51,
    cy: 556.09,
    rx: 133.1,
    ry: 131.51
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 706.51,
    cy: 556.09,
    rx: 107.13,
    ry: 105.86
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 706.51,
    cy: 556.09,
    rx: 46.36,
    ry: 45.81
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 357.11,
    cy: 676.3,
    rx: 46.36,
    ry: 45.81
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 357.11,
    cy: 676.3,
    rx: 24.88,
    ry: 24.59
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M281.81,548.2h74.38a28.6,28.6,0,0,1,28.6,28.6v28.66a0,0,0,0,1,0,0H253.21a0,0,0,0,1,0,0V576.8A28.6,28.6,0,0,1,281.81,548.2Z",
    transform: "translate(-314.45 394.52) rotate(-45)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 552.61,
    cy: 549.54,
    r: 24.93
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 629.25,
    cy: 549.54,
    r: 17.63
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 724.14,
    cy: 549.54,
    r: 17.63
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M739.86,211.73l28.77-28.47a22.6,22.6,0,0,1,32,.24l.17.17a22.62,22.62,0,0,1-.34,32L771.57,244a22.6,22.6,0,0,1-31.85-.23h0A22.61,22.61,0,0,1,739.86,211.73Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjects05);
export default __webpack_public_path__ + "static/media/objects-05.de15f2819d5b3ca4cf175c8bf0f2604a.svg";
export { ForwardRef as ReactComponent };